
import { gsap }                                     from 'gsap';
//import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
//gsap.registerPlugin(ScrollToPlugin);
import { debounce as _debounce }                    from 'underscore';
import { disableBodyScroll, enableBodyScroll }      from 'body-scroll-lock';
import '@benmajor/jquery-touch-events';
// import 'jquery-clickout';
import slideshowCtrl                                from './slideshowCtrl';
import lazySizes                                    from 'lazysizes';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el:                    false,
            $trigger:               false,
            main:                   undefined,
            time_transition_on:     0.6,
            time_transition_off:    0.4,
            forceOpen:              false,

            forceImageReload:       true,
            addCaptions:            true,

            setHighResImage:        true
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'image_gallery_window';
		this.$el 			= 	this.options.$el;
        this.$trigger       =   this.options.$trigger;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.$html = $('html');
        this.$win  = $(window);

        // attach to the body!!!!
        if( ! this.$el.parent().is( 'body' ) ){
            $('body').append( this.$el );
        }

    	this.$close     = this.$el.find( '.win-close' );
        this.$window     = this.$el.find( '.window' );

        this.injectSlideshow();


    	this.addEvents( true );

        if ( this.options.forceOpen ){
            this.forceOpen()
        }
	}

    injectSlideshow(){
        
        let $slider = this.$el.find( '.slick-slider' ), slide, $el, $img, $captions, srcset, src, $wrap;

        // if there are no images passed lets get those from trigger ...
        if ( this.$trigger.length > 0 && this.$el.find( '.slide-wrap' ).length <= 0 && $slider.length > 0  ){

            this.$trigger.each( (i,el)=>{

                $el = $(el);

                // set the index to open the correct slide on trigger
                $el.attr( 'data-enlarge-index', i );

                // get the image wrapper
                $img = $el.find( '.img-wrapper' );

                // captions
                $captions = $el.find( '.captions' );
                if ( $captions.length <= 0 ){
                    $captions = $el.find( '.caption' );
                }

                if ( $img.length > 0 ){


                    if ( this.options.setHighResImage ){

                        srcset = $img.find( 'img' ).attr( 'data-srcset' ).split(', ');
                        src = srcset[srcset.length-1].split( ' ' )[0];
                        $wrap = $img.remove( 'img' );
                        $wrap.html( '<img src="' + src + '"/>' );

                    }


                    slide = '<div class="slide-wrap">';
                    slide       += '<div class="image-sizer">';

                    if ( this.options.setHighResImage ){
                        slide           += $wrap.parent().html();
                    }
                    else{
                         slide           += $img[0].outerHTML; 
                    }
                   
                    slide       += '</div>';

                    if ( this.options.addCaptions ){
                        slide   += '<div class="captions"><div class="wrap inner">' + ($captions.length>0?$captions.html():'') + '</div></div>'; 
                    }

                    slide += '</div>';

                    $slider.append( slide ); 
                }

            });

            if ( this.options.forceImageReload ){
                this.forceLazyloadImageAgain();
            }
            
        }
    }

    forceLazyloadImageAgain(){
        this.$el.find( 'img' ).each( (i,el) => {
            $(el).attr( 'class', 'lazyload' );
            lazySizes.loader.unveil( el );
        })
    }

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
        this.initSlideshow( b );

		if ( b ){
    		if ( this.$html.hasClass( 'touch' ) ){
    			this.$close.on( 'tap', (e)=>this.open(false,e) );
                this.$el.find( 'img' ).on( 'tap', ()=>this.onImageTap() )
    		}
    		else{
    			this.$close.on( 'click', (e)=>this.open(false,e) );
    		}
            this.$el.find( '.slide-wrap' ).on( 'click', (e)=>this.onClickOutImages(e) );              
            this.$trigger.on( 'click', (e)=>this.triggerWindow(e) );

		}
		else{
    		if ( this.$html.hasClass( 'touch' ) ){
    			this.$close.off( 'tap', (e)=>this.open(false,e) );
    		}
    		else{
    			this.$close.off( 'click', (e)=>this.open(false,e) );
    		}
            this.$trigger.off( 'click', (e)=>this.triggerWindow(e) );
            this.$el.find( '.slide-wrap' ).off( 'click', (e)=>this.onClickOutImages(e) );
		}

        this.addKeyboardsEvents( b );

        this.debounceResize(b);
	}


    addKeyboardsEvents(b){
        if ( b ){
            $( document ).on( 'keydown', (e)=>this.onKeyDown(e) );
        }
        else{
            $( document ).off( 'keydown', (e)=>this.onKeyDown(e) )
        }
    }

    onKeyDown(e){
        switch( e.code ){
            case 'Escape':
                this.open( false, e );
                break;
        }
    }

    initSlideshow(b){
        let $s =  this.$el.find( '.module_slideshow' ), args;
        if ( b ){


            /*
            $s.find( '.slick-slider' ).on( 'beforeChange', (event, slick, currentSlide, nextSlide) =>{
                
            });
            */
            $s.find( '.slick-slider' ).on( 'afterChange', (event, slick, currentSlide ) =>{
                this.afterSlideChange();
            });

            args = {
                dots: false,
                infinite: true,
                fade: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                arrows: true,
                autoplay: false,
                prevArrow : $s.find('.arrow.left'),
                nextArrow : $s.find('.arrow.right'),


                crossFade : true,
                gsap:       false,

                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            fade: false,
                            speed: 300,
                            swipeToSlide: true,
                            touchThreshold: 40
                        }
                    }
                ]
            }
            // important: Remember to pass the dom element!!!
            this.slider = new slideshowCtrl( {
                $el : $s,
                customArgs: true,
                args: args
            });

            if ( $s.find( '.slide-wrap').length === 1 ){
                $s.find( '.arrow' ).addClass( 'visually-hidden' );
            }

            //setTimeout( ()=>this.delayInit(), 100 );
            //this.setMenuIndex(0);
           

        }
        else{
            this.slider.destroy();
        }
    }

    afterSlideChange(){
        if ( this.afterSetIndex ){
            this.$el.find( '.module_slideshow' ).addClass( 'slide-changed' );
        }
        else{
            this.afterSetIndex = true
        }
        
    }

    onImageTap(){
        if ( this.$el.find( '.module_slideshow' ).hasClass( 'slide-changed' ) ){
            this.$el.find( '.module_slideshow' ).removeClass( 'slide-changed' )
        }
        else{
            this.$el.find( '.module_slideshow' ).addClass( 'slide-changed' )   
        }
        this.afterSetIndex = false;
    }

    resetSlider(){
        this.$el.find( '.module_slideshow' ).removeClass( 'slide-changed' );
        this.afterSetIndex = false;
    }

    triggerWindow(e){
        e.preventDefault();
        let $a = $(e.currentTarget), index = parseInt( $a.attr('data-enlarge-index') );
        this.resetSlider();
        if ( index >= 0 ){
            this.setSlideshowIndex( index );
        }
        this.open( true );
        return false;
    }

    setSlideshowIndex( index ){
        let $slick = this.$el.find( '.slick-slider' );
        if ( $slick.length > 0 ){
            $slick.slick( 'slickGoTo', index, true );
        }
    }

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( (e) => this.onResize(e), 137 );
            this.$win.on( 'resize', this._debResize );

            window.addEventListener("orientationchange", this._debResize );

            this.onResize();
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
                window.removeEventListener("orientationchange", this._debResize );  
            }

        }
    }

    onClickOutImages(e){
        if( ! $(e.target).is( 'img' ) ){
            this.open( false, e );
        }
    }

    addClickOut(b){
        let $i = this.$el.find( 'iframe' );
        if ( $i.length > 0 ){
            if ( b ){
                $i.on( 'clickout', (e)=>this.open(false,e) );
            }
            else{
                $i.off( 'clickout', (e)=>this.open(false,e) );
            }
        }
    }

    onResize(e){
        let margin = 60, w = this.$win.width(), h = this.$win.height(), ww, hh, $s, p;

        //h = (typeof window.outerHeight != 'undefined')?Math.max(window.outerHeight, h):h;

        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        h = window.innerHeight;


        this.$el.height( h );
        // set slides to max height
        this.$el.find( '.slide-wrap' ).height( h );


        // rest the vertical margins
        h -= 2*margin;

        //h = Math.min( 1400, h );
        //w = Math.min( 1800, w );

        // center the image sizer on max avail with/height
        this.$el.find( '.img-wrapper' ).each( (i,el) => {
            $s = $(el);

            ww = parseInt( $s.attr( 'data-width' ) );
            hh = parseInt( $s.attr( 'data-height') );

            p = Math.min( w/ww, h/hh );

            $s.css({
                'padding-bottom': (hh/ww*100) + '%'
            });
            $s.removeClass( 'cover' ).removeClass( 'contain' );

            $s = $s.parent( '.image-sizer' );
            $s.width( ww*p );

        });
    }

    onComplete(b){
        if ( !b ){
            this.addClickOut( false );
            this.$el.removeClass( 'is-open' );
        }
        else{
            this.addClickOut( true );
        }
    }

    //---------------------------------------- METHODS ---------------------------------------//
    open(b,e){

        if ( e ){
            e.preventDefault();
        }

        let t = gsap.timeline(), dy = 0;
    	if ( b ){

            this.$html.addClass( 'modal-open' );
            this.$el.addClass( 'is-open' );
            //this.$el.find( '.scroll-content' ).scrollTop(0);
            t.fromTo( this.$window, { y: dy }, {y:0, ease:'power2.easeOut',duration: this.options.time_transition_on} );
			t.fromTo( this.$el, { opacity:0}, {opacity:1, ease:'power2.easeOut', duration: this.options.time_transition_on, onComplete: ()=>this.onComplete(b)}, "-=" + this.options.time_transition_on );
            disableBodyScroll( this.$window[0] );

            this.$win.trigger( 'resize' );
    	}
    	else{

            this.$html.removeClass( 'modal-open' );
        
            t.fromTo( this.$window, { y:0 }, {y: - dy, ease:'power2.easeOut',duration: this.options.time_transition_off} );
    		t.to( this.$el, {opacity:0, ease:'power2.easeOut', duration: this.options.time_transition_off, onComplete: ()=>this.onComplete(b) }, "-=" + this.options.time_transition_off );
            enableBodyScroll( this.$window[0] );
    	}

        return false
    }

    destroy(){
		if ( this.$el.length > 0 ){
    		this.addEvents( false );
            this.$el.remove()
    	}
    }

}


